class config{

    static customerFromId = "tg-customerForm";
    static videocallwrapperdivId = "tg-video-call-iframe";
    static APIBASEURL = process.env.API_BASEURL;
    static tgvideoIconId = "tg-join-meeting-icon";
    static tgvideoInProgressIconId = "tg-join-meeting-inprogress-icon";
}

export default config;